import { Component, contentChildren, effect, input, output } from '@angular/core';

import { TabComponent } from './tab.component';

export interface TabChangeEvent {
  tabId: string;
}

@Component({
  selector: 'app-tabs',
  template: `
    <ul class="nav nav-tabs">
      @for (tab of tabs(); track tab.tabId()) {
        <li (click)="onSelectTab(tab)" data-toggle="tab" [class.autoWidth]="tab.autoWidth()" [class.active]="tab.active()" [attr.aria-selected]="tab.active()">
          <a title="{{tab.tabTitle()}}">{{tab.tabTitle()}}</a>
        </li>
      }
    </ul>
    <ng-content></ng-content>
  `,
})
export class TabsComponent {

  readonly selectedId = input.required<string>();
  readonly tabChanged = output<TabChangeEvent>();

  readonly tabs = contentChildren(TabComponent);

  private activeTab : TabComponent | null = null;

  constructor() {
    effect(() => {
      this.selectedId();
      this.tabs();

      this.preselectTab();
    });
  }

  private preselectTab(): void {
    const tabs = this.tabs();
    if (tabs.length === 0) {
      return;
    }

    if (!this.selectedId()) {
      this.selectTab(tabs[0]);
      return;
    }

    const tab = this.findTab(this.selectedId());
    if (tab) {
      this.selectTab(tab);
      return;
    }

    this.selectTab(tabs[0]);
  }

  onSelectTab(tab: TabComponent) {
    this.selectTab(tab);
    this.tabChanged.emit({ tabId: tab.tabId() });
  }

  selectTab(tab: TabComponent) {
    if (tab === this.activeTab) {
      return;
    }

    // deactivate active tab
    if (this.activeTab) {
      this.activeTab.active.set(false);
    }

    // activate the tab the user has clicked on.
    this.activeTab = tab;
    tab.active.set(true);
  }

  private findTab(id: string): TabComponent | undefined {
    return this.tabs().find(t => t.tabId() === id);
  }
}
